export default new Map([
  [2014, {
    period: 'tax',
    taxReturn: {
      year: '2014',
      formName: '1040C',
      rid: 446,
      __typename: 'TaxReturn'
    }
  }],
  [2015, {
    period: 'tax',
    taxReturn: {
      year: '2015',
      formName: '1040C',
      rid: 447,
      __typename: 'TaxReturn'
    }
  }],
  [2016, {
    period: 'tax',
    taxReturn: {
      year: '2016',
      formName: '1040C',
      rid: 448,
      __typename: 'TaxReturn'
    }
  }],
  [2017, {
    period: 'tax',
    taxReturn: {
      year: '2017',
      formName: '1040C',
      rid: 449,
      __typename: 'TaxReturn'
    }
  }],
  [2018, {
    period: 'tax',
    taxReturn: {
      year: '2018',
      formName: '1040C',
      rid: 450,
      __typename: 'TaxReturn'
    }
  }]
])
